import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  items: [],
  deletedId: -1,
  openAlert: false,
  deleteSuccess: true,
  requestAccountFail: false
};

export default (state = initialState, action) => {
  
  switch (action.type) {
    case ActionTypes.REQUEST_ACCOUNT:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
        deletedId: -1,
        openAlert: false,
        requestAccountFail: false
      }

    case ActionTypes.RECEIVE_ACCOUNT:
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        items: action.items,
        totalRows: action.items.DataCount,
        lastUpdated: action.receivedAt,
        requestAccountFail: false
      }
    case ActionTypes.CREATE_ACCOUNT:
      return {
        ...state,
      }
    case ActionTypes.UPDATE_ACCOUNT:
      return {
        ...state,
      }
    case ActionTypes.DELETE_ACCOUNT:
      const { items } = state;
      if (items) {
        items.detailData = items.detailData.filter(itm => itm.login_email  !== action.deletedEmail);
        if (Number(items.DataCount) > 0) {
          items.DataCount = (Number(items.DataCount) - 1).toString();
        }
      }
      return {
        ...state,
        items,
        openAlert: true,
        deleteSuccess: true,
      }
    
    case ActionTypes.DELETE_ACCOUNT_FAIL:
      return {
        ...state,
        openAlert: true,
        deleteSuccess: false,
      }

    case ActionTypes.CLOSE_ALERT_DELETE_ACCOUNT:
      return {
        ...state,
        openAlert: false,
        // deleteSuccess: true,
      }

    case ActionTypes.REQUEST_ACCOUNT_FAIL:
      return {
        ...state,
        isFetching: false,
        items: action.items,
        openAlert: true,
        requestAccountFail: true,
      }

    default:
      return state
  }
}
